import { useDefaultSortingItem } from 'src/hooks'
import { useLocales } from 'src/locales'

export const useTreatmentConfig = () => {
  const { t } = useLocales()

  const { defaultSortingOption } = useDefaultSortingItem()

  const options = [
    defaultSortingOption,
    {
      value: 'startDate',
      label: t('treatments.treatment_start_date_asc')
    },
    {
      value: '-startDate',
      label: t('treatments.treatment_start_date_desc')
    },
    {
      value: 'endDate',
      label: t('treatments.treatment_end_date_asc')
    },
    {
      value: '-endDate',
      label: t('treatments.treatment_end_date_desc')
    },
    {
      value: 'treatmentType',
      label: t('treatments.treatment_type_asc')
    },
    {
      value: '-treatmentType',
      label: t('treatments.treatment_type_desc')
    }
  ]

  return { options }
}
